import styled from 'styled-components';

interface IStyleProps {
  radius?: number
  backgroundColor?: string
}
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BigMenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  display: flex;
  margin: 60px 0 0 0;
  align-items: center;
  justify-content: space-around;
  width: 100%;
`;

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const Dot = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50px;
  background-color: ${(props: IStyleProps) => {
    return props.backgroundColor;
  }};
  /* box-shadow: 0px 4px 4px 0px #00000040; */
  @media (max-width: 450px) {
    height: 6px;
    width: 6px;
  }
`;

export const MenuText = styled.p`
  margin: 0 0 0 10px;
  font-weight: 300;
  font-size: 14px;
  color: #757575;
  @media (max-width: 450px) {
    font-size: 8px;
  }
`;

export const Percentage = styled.p`
  font-weight: 700;
  font-size: 10px;
  color: ${(props) => {
    return props.color;
  }};
`;

export const Svg = styled.svg`
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  border-radius: ${(props: IStyleProps) => (props.radius ? props.radius * 2 : 0)}px;
`;
